import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start'
    },
    description: {
      marginTop: '5px',
      color: palette.title.primary
    },
    onClick: {
      cursor: 'pointer'
    },
    catchPhrase: {
      height: '68px',
      marginTop: '2px',
      display: 'table-cell',
      verticalAlign: 'middle'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
